import { Component } from '@angular/core';
import {FaqService} from "../../../services/faq.service";
import {Faq} from "../../../models/faq";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrl: './faq.component.css',
    standalone: false
})
export class FaqComponent {
  loading = false;
  listaFaqs: Faq[] = [];
  public colunas = [`Titulo`, 'Tipo', 'Status'];
  public linhas: any[] = [];

  constructor(private faqService: FaqService,
              private toastr: ToastrService) {
    this.buscarFaqs();
  }

  private buscarFaqs(){
    this.loading = true;
    this.faqService.buscarAtivos().subscribe((response) => {
      if(response.sucesso){
        this.listaFaqs = response.dados;
      }
      this.loading = false;
    }, (error) => {
      this.toastr.warning("Erro ao buscar faqs");
      this.loading = false;
    });
  }
}
